module.exports = __webpack_public_path__ + "static/media/RecomendaNossaSenhora.963886d3.jpg";